import { Component, OnInit,ViewChild} from '@angular/core';
import { DashboardService } from '../dashboard.service'
import { Subscription } from 'rxjs'
import { MatDialog } from '@angular/material/dialog';
import { EditDialogComponent } from './edit-dialog/edit-dialog.component';
import { InsertDialogComponent } from './insert-dialog/insert-dialog.component';
import {Training} from '../../models/training.model'
import {DeleteDialogComponent} from './delete-dialog/delete-dialog.component'
import { MatSnackBar } from '@angular/material/snack-bar';
import {AdminLanguageService} from 'src/app/modules/services/admin-language-service/admin-language.service'
import {Folder} from '../../models/folder.model';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {InsertTrainingsDialogComponent} from './insert-trainings-dialog/insert-trainings-dialog.component';

@Component({
    selector: 'app-admin-training-folder',
    templateUrl: './admin-training-folder.component.html',
    styleUrls: ['./admin-training-folder.component.scss'],
    standalone: false
})

export class AdminTrainingFolderComponent implements OnInit {

  displayedColumns: string[] = ['name', 'description', 'dateCreated', 'actions'];
  dataSource;
  trainings: Training[];
  labels;
  labelsSub: Subscription;
  folders: Folder[]
  treeControl: NestedTreeControl<Folder>
  //hasChild = (_: number, folder: Folder) => Array.isArray(folder.children) && folder.children.length > 0;
  hasChild = (_: number, folder: Folder) => !!folder.children && folder.children.length > 0;
  constructor(private dashboardService:DashboardService,public dialog: MatDialog,public snackBar:MatSnackBar,public adminLanguageService: AdminLanguageService) { }

  ngOnInit(): void {
    this.dataSource = new MatTreeNestedDataSource()
    this.getTrainings();
    this.getLang();
    this.treeControl = new NestedTreeControl<Folder>(this.treeControlFunction)

  }

  treeControlFunction(folder: Folder) {
    return folder.children
  }

  getTrainings(){
    this.dashboardService.getTrainings().subscribe((trainings)=>{
      let trngs = trainings as Training[]
      trngs.forEach(t => {
        t.date = t.dateCreated.toLocaleString()
        t.date = t.date.substring(8,10)+"."+t.date.substring(5,7)+"."+t.date.substring(0,4)+"."
      })
      this.trainings = trngs
      this.getFoldersAndPopulate()
    })
  }

  getFoldersAndPopulate() {
    this.dashboardService.getFolders().subscribe((folders: Folder[])=>{
      this.folders = folders
      this.dataSource.data = this.folders
    })
  }

  getLang(){
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
      })
  }

  public doFilter = (value: string) => {
    this.dataSource.filter = value
  }

  openEditDialog(training){
    const dialogRef=this.dialog.open(EditDialogComponent,{
      width:"500px",
      height: "600px",
      data:training
    })

    dialogRef.afterClosed().subscribe((result)=>{
      this.dataSource.data = null
      this.getFoldersAndPopulate()
    })
  }
  openDeleteDialog(folder: Folder){
    const dialogRef=this.dialog.open(DeleteDialogComponent,{
      width:"500px",
      data: folder
    })
    dialogRef.afterClosed().subscribe((result)=>{
      this.dataSource.data = null
      this.getFoldersAndPopulate()
    })
  }

  openInsertDialog(id: string = null){
    const dialogRef=this.dialog.open(InsertDialogComponent,{
      width:'500px',
      height: '600px',
      data: {folderId: id}
    })
    dialogRef.afterClosed().subscribe(response=>{
      this.dataSource.data = null
      this.getFoldersAndPopulate()
    })
  }

  openInsertTrainingsDialog(id, content){
    const dialogRef=this.dialog.open(InsertTrainingsDialogComponent,{
      width:'500px',
      height: '600px',
      data: {folderId: id, assignedTrainings: content ?? []}
    })
    dialogRef.afterClosed().subscribe(response=>{
      this.dataSource.data = null
      this.getFoldersAndPopulate()
    })
  }

}

